import * as tslib_1 from "tslib";
import React from 'react';
import classnames from 'classnames';
import NotificationAnimator from './_partials/NotificationAnimator';
import { useIsMounted } from '../utils/hooks/useIsMounted';
import s from './Notifications.scss';
var Notifications = function (_a) {
    var queue = _a.queue, wrapperClassName = _a.wrapperClassName, props = tslib_1.__rest(_a, ["queue", "wrapperClassName"]);
    // react-spring leaks in ssr, so must avoid rendering it
    var mounted = useIsMounted();
    return (React.createElement("div", { className: classnames(s['root'], wrapperClassName) }, mounted && (React.createElement(NotificationAnimator, { queue: queue, notificationProps: props }))));
};
export default Notifications;
//# sourceMappingURL=Notifications.js.map